import { useState } from 'react';
import { Box, Grid } from '@material-ui/core';
import { useDefaultCadastroStyles } from '../cadastros/components/default-cadastro-styles';
import { PropagandaEdicaoHeader } from './components/propaganda-edicao-header/propaganda-edicao-header';
import { TabSaurusContent, TabSaurusLabel, TabsSaurus } from 'views/components/tabs/tabs-saurus';
import { useParams } from 'react-router-dom';
import { PropagandaResposta } from './components/propaganda-resposta/propaganda-resposta';
import { PropagandaEdicaoContent } from './components/propaganda-edicao-content/propaganda-edicao-content';
import { EnumTipoPessoas } from 'model/enums/enum-tipo-pessoas';
import { useSessaoAtual } from 'services/app';
import { useStyles } from './propaganda-edicao-styles';

interface paramProps {
    propagandaId: string
}

const PropagandaEdicaoPage = () => {
    const defaultClasses = useDefaultCadastroStyles();
    const classes = useStyles()

    const [tabIndex, setTabIndex] = useState<number>(1);

    const { tipoUsuario, usuario } = useSessaoAtual()
    const { propagandaId } = useParams<paramProps>();
    const [revendaIdPropaganda, setRevendaIdPropaganda] = useState('');

    const isSoftwareHouse = tipoUsuario() === EnumTipoPessoas.SoftwareHouse;

    const podeExcluirPropaganda = isSoftwareHouse ? true : usuario?.Id === revendaIdPropaganda;

    return (
        <Grid className={defaultClasses.root}>
            <Grid className={defaultClasses.header}>
                <PropagandaEdicaoHeader podeExcluirPropaganda={podeExcluirPropaganda} />
            </Grid>
            <Box className={classes.box}>
                <Grid
                    container
                    className={defaultClasses.list}
                >
                    <Grid item xs={12}>
                        <TabsSaurus
                            selectedTabIndex={tabIndex}
                            onChange={(tab) => setTabIndex(tab)}
                            hideTabs={isSoftwareHouse ? false : usuario?.Id !== revendaIdPropaganda}
                            tabsLabel={[
                                new TabSaurusLabel('Dados da campanha', 0),
                                new TabSaurusLabel('Destinatários', 1)
                            ]}
                            tabsContent={[
                                new TabSaurusContent(0, (
                                    <PropagandaEdicaoContent
                                        setRevendaIdPropaganda={setRevendaIdPropaganda}
                                        id={propagandaId}
                                        disabled={false} />
                                )),
                                new TabSaurusContent(1, (
                                    <PropagandaResposta
                                        propagandaId={propagandaId}
                                    />
                                ))
                            ]}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Grid>
    );
};

export default PropagandaEdicaoPage;

